import { useEffect } from 'react'
import { Button } from '@/components/ui/button'

export function ListPagination({ data, page, setPage, isFetching, error }) {
  // A deletion can remove the last page. Recover instead of stranding the user
  // on DRF's "Invalid page" response.
  useEffect(() => {
    if (error?.response?.status === 404 && page > 1) setPage(1)
  }, [error, page, setPage])

  const count = Array.isArray(data) ? data.length : data?.count
  return (
    <nav aria-label="Paginazione elenco" className="flex flex-wrap items-center justify-between gap-3 py-4">
      <p className="text-sm text-muted-foreground" aria-live="polite">
        {error ? 'Impossibile caricare l’elenco.' : count == null ? 'Caricamento elenco…' : `${count} risultati · Pagina ${page}`}
      </p>
      <div className="flex items-center gap-2">
        <Button type="button" variant="outline" size="sm" disabled={page <= 1 || isFetching} onClick={() => setPage(1)}>Prima</Button>
        <Button type="button" variant="outline" size="sm" disabled={page <= 1 || isFetching} onClick={() => setPage(page - 1)}>Precedente</Button>
        <Button type="button" variant="outline" size="sm" disabled={!data?.next || isFetching || Boolean(error)} onClick={() => setPage(page + 1)}>Successiva</Button>
      </div>
    </nav>
  )
}
